import React from 'react';
export function SalesFooter() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#5C3D2E] text-[#FFF8E7] py-12 px-4 text-center" data-id="element-98">
      <div className="max-w-4xl mx-auto" data-id="element-99">
        <h3 className="text-2xl font-serif font-bold mb-6 text-[#D4A017]" data-id="element-100">
          Cenas en 1 Olla
        </h3>

        <p className="text-sm opacity-80 mb-8 max-w-2xl mx-auto" data-id="element-101">
          Este producto no sustituye el consejo médico profesional. Consulte a
          su médico antes de comenzar cualquier régimen alimenticio,
          especialmente si tiene condiciones médicas preexistentes.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm opacity-90 mb-8" data-id="element-102">
          <a href="#" className="hover:text-[#D4A017] transition-colors" data-id="element-103">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-[#D4A017] transition-colors" data-id="element-104">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-[#D4A017] transition-colors" data-id="element-105">
            Contacto
          </a>
        </div>

        <p className="text-sm opacity-60" data-id="element-106">
          &copy; {currentYear} Cenas en 1 Olla. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}